import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {Link} from "react-router-dom";
import { fetchWithAuth } from "../utils/fetchWithAuth";

function TermsAgreement({ onNext }) {
  const [terms, setTerms] = useState({ service: false, privacy: false, optional: false, over14: false });
  const [contents, setContents] = useState({ service: "", privacy: "", optional: "" });
  const [agreeAll, setAgreeAll] = useState(false);

  const handleChange = (key) => {
    const newTerms = { ...terms, [key]: !terms[key] };
    setTerms(newTerms);
    setAgreeAll(newTerms.service && newTerms.privacy && newTerms.over14);
  };

  useEffect(() => {
    const loadTerms = async () => {
      const [service, privacy, optional] = await Promise.all([
        fetch("/terms/service.txt").then((res) => res.text()),
        fetch("/terms/privacy.txt").then((res) => res.text()),
        fetch("/terms/optional.txt").then((res) => res.text()),
      ]);
      setContents({ service, privacy, optional });
    };
    loadTerms();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("현재 회원가입 기능이 일시 중단되었습니다.");
    return;

    // if (terms.service && terms.privacy && terms.over14) {
    //   onNext(terms.optional);
    // } else {
    //   alert("필수 약관에 모두 동의해주세요.");
    // }
  };

  return (
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-white">
        <header className="w-full flex flex-col md:flex-row justify-between items-center px-4 py-4 border-b bg-white dark:bg-gray-800">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <h1 className="text-xl font-bold text-blue-600 dark:text-blue-300">J_Universe 회원가입</h1>
            <nav className="mt-2 text-sm">
              <Link to="/" className="hover:text-blue-400">J_Universe</Link>
              <span className="mx-2">|</span>
            </nav>
          </div>
        </header>

        <form
          onSubmit={handleSubmit}
          className="flex flex-col items-center justify-center p-6 min-h-screen text-white bg-gray-900"
        >
          <h2 className="text-2xl font-bold mb-6">약관 동의</h2>

          <div className="mb-6 border p-4 rounded bg-[#111827] w-full max-w-md mx-auto">
            <textarea
              readOnly
              value={contents.service}
              className="w-full min-h-[160px] max-h-[200px] text-sm text-black p-2 rounded whitespace-pre-wrap overflow-y-auto"
            />
            <label className="block mt-2 text-sm font-medium text-white">
              <input type="checkbox" checked={terms.service} onChange={() => handleChange("service")} className="mr-2" />
              이용약관 동의 (필수)
            </label>
          </div>

          <div className="mb-6 border p-4 rounded bg-[#111827] w-full max-w-md mx-auto">
            <textarea
              readOnly
              value={contents.privacy}
              className="w-full min-h-[160px] max-h-[200px] text-sm text-black p-2 rounded whitespace-pre-wrap overflow-y-auto"
            />
            <label className="block mt-2 text-sm font-medium text-white">
              <input type="checkbox" checked={terms.privacy} onChange={() => handleChange("privacy")} className="mr-2" />
              개인정보 수집·이용 동의 (필수)
            </label>
          </div>

          <div className="mb-6 border p-4 rounded bg-[#111827] w-full max-w-md mx-auto">
            <textarea
              readOnly
              value={contents.optional}
              className="w-full min-h-[160px] max-h-[200px] text-sm text-black p-2 rounded whitespace-pre-wrap overflow-y-auto"
            />
            <label className="block mt-2 text-sm font-medium text-white">
              <input type="checkbox" checked={terms.optional} onChange={() => handleChange("optional")} className="mr-2" />
              선택 정보 활용 동의 (선택)
            </label>
          </div>

          <div className="mb-4">
            <label>
              <input type="checkbox" checked={terms.over14} onChange={() => handleChange("over14")} className="mr-2" />
              본인은 만 14세 이상입니다. (필수)
            </label>
          </div>

          <div className="mb-4">
            <label className="font-semibold">
              <input
                type="checkbox"
                className="mr-2"
                checked={agreeAll}
                onChange={(e) => {
                  const val = e.target.checked;
                  setAgreeAll(val);
                  setTerms({
                    service: val,
                    privacy: val,
                    optional: val,
                    over14: val,
                  });
                }}
              />
              전체 약관에 동의합니다
            </label>
          </div>

          <div className="mt-4">
            {/*<button type="submit" className="bg-blue-600 px-6 py-2 rounded hover:bg-blue-700">다음 단계</button>*/}
          </div>
        </form>
    </div>
  );
}

function SignupForm({ optionalAgree, onBack }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [nickname, setNickname] = useState("");
  const [result, setResult] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [locked, setLocked] = useState(false); // 성공 후 폼 잠금
  const [emailChecked, setEmailChecked] = useState(false);
  const [nicknameChecked, setNicknameChecked] = useState(false);
  const [emailResult, setEmailResult] = useState("");
  const [nicknameResult, setNicknameResult] = useState("");
  const [emailFormatError, setEmailFormatError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const validateEmailFormat = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setResult("");

    if (!emailChecked || !nicknameChecked) {
      setResult("❌ 이메일과 닉네임 중복확인을 완료해주세요.");
      return;
    }

    if (locked || submitting) return;

    setSubmitting(true);

    setResult("회원가입 진행 중...");
    try {
      const res = await fetchWithAuth(`/pre-signup`, {
        method: "POST",
        body: JSON.stringify({email, password, nickname, optional_agree: optionalAgree}),
      });

      const data = await res.json();
      if (res.ok) {
        setLocked(true);
        // 안내 전용 페이지로 이동 (이메일 쿼리 전달)
        navigate(`/verify-sent?email=${encodeURIComponent(email)}`);
      } else {
        setResult(`❌ ${data.detail || "요청을 처리할 수 없습니다."}`);
      }
    }catch (err){
      setResult("❌ 네트워크 오류가 발생했습니다.");
    }finally {
      setSubmitting(false);
    }
  };

  const checkEmail = async () => {
    if (!validateEmailFormat(email)) {
      setEmailFormatError("❌ 올바른 이메일 형식이 아닙니다.");
      return;
    }
    const res = await fetchWithAuth(`/check-email?email=${email}`);
    const data = await res.json();
    if (data.available) {
      setEmailChecked(true);
      setEmailResult("✅ 사용 가능한 이메일입니다.");
    } else {
      setEmailChecked(false);
      setEmailResult("❌ 이미 사용 중인 이메일입니다.");
    }
  };

  const checkNickname = async () => {
    const res = await fetchWithAuth(`/check-nickname?nickname=${nickname}`);
    const data = await res.json();
    if (data.available) {
      setNicknameChecked(true);
      setNicknameResult("✅ 사용 가능한 닉네임입니다.");
    } else {
      setNicknameChecked(false);
      setNicknameResult("❌ 이미 사용 중인 닉네임입니다.");
    }
  };

  return (
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-white">
        <header className="w-full flex flex-col md:flex-row justify-between items-center px-4 py-4 border-b bg-white dark:bg-gray-800">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <h1 className="text-xl font-bold text-blue-600 dark:text-blue-300">J_Universe 회원가입</h1>
            <nav className="mt-2 text-sm">
              <Link to="/" className="hover:text-blue-400">J_Universe</Link>
              <span className="mx-2">|</span>
            </nav>
          </div>
        </header>

        <div className="flex flex-col items-center justify-center min-h-screen text-white bg-gray-900">
          <h1 className="text-4xl font-bold mb-4">회원가입</h1>
          <h3 className="mb-4 text-red-300"> ※ Email은 문의 등의 조치가 필요한 경우 관리자와의 연락 수단이되므로 사용가능한 Email을 정확히 입력해주시기 바랍니다.</h3>
           <form className="space-y-4" onSubmit={handleSubmit}>
            <div className="flex flex-col space-y-2">
              <div className="flex space-x-2">
                <input
                  type="email"
                  placeholder="이메일"
                  required
                  value={email}
                  onChange={(e) => {
                    const val = e.target.value;
                    setEmail(val);
                    setEmailChecked(false);
                    setEmailResult("");
                    if (val.length > 0 && !validateEmailFormat(val)) {
                      setEmailFormatError("❌ 올바른 이메일 형식이 아닙니다.");
                    } else {
                      setEmailFormatError("");
                    }
                  }}
                  disabled={submitting || locked}
                  className="bg-white text-black p-2 rounded w-72"
                />
                <button
                  onClick={checkEmail}
                  type="button"
                  className="bg-blue-500 text-white px-2 rounded hover:bg-blue-600"
                  disabled={submitting || locked}
                >
                  중복확인
                </button>
              </div>
              <p className="text-sm text-red-400">{emailFormatError || emailResult}</p>

              <div className="flex space-x-2">
                <input
                  type="text"
                  placeholder="닉네임"
                  required
                  value={nickname}
                  onChange={(e) => {
                    setNickname(e.target.value);
                    setNicknameChecked(false);
                    setNicknameResult("");
                  }}
                  disabled={submitting || locked}
                  className="bg-white text-black p-2 rounded w-72"
                />
                <button
                  onClick={checkNickname}
                  type="button"
                  className="bg-blue-500 text-white px-2 rounded hover:bg-blue-600"
                  disabled={submitting || locked}
                >
                  중복확인
                </button>
              </div>
              <p className="text-sm">{nicknameResult}</p>
              <input
                type="password"
                placeholder="비밀번호 (6자 이상)"
                required
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (e.target.value.length < 6) {
                    setPasswordError("비밀번호는 최소 6자 이상이어야 합니다.");
                  } else {
                    setPasswordError("");
                  }
                }}
                disabled={submitting || locked}
                className="bg-white text-black p-2 rounded w-72"
              />

              {passwordError && (
                <p className="text-red-400 text-sm mt-1">{passwordError}</p>
              )}
            </div>

            <div className="flex space-x-2">
              <button type="button" onClick={onBack} className="bg-blue-500 text-white mt-4 px-4 py-2 rounded hover:bg-blue-600">
                이전
              </button>
            <button
              type="submit"
              disabled={password.length < 6 || !nicknameChecked || submitting || locked}
              className={`mt-4 px-4 py-2 rounded ${
                password.length < 6 || !nicknameChecked || submitting || locked
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-green-500 hover:bg-green-600"
              } text-white`}
            >
              인증메일 보내기
            </button>
            </div>
          </form>
          <div className="mt-4 text-sm">{result}</div>
        </div>
    </div>
  );
}

export default function SignupPage() {
  const [step, setStep] = useState(1);
  const [optionalAgree, setOptionalAgree] = useState(false);

  return step === 1 ? (
    <TermsAgreement onNext={(optional) => {
      setOptionalAgree(optional);
      setStep(2);
    }} />
  ) : (
    <SignupForm optionalAgree={optionalAgree} onBack={() => setStep(1)} />
  );
}